var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row text-left px-3 mt-0 h-100 h2",staticStyle:{"background-color":"#35424a"}},[_c('div',{staticClass:"col-md-12 text-white px-5",staticStyle:{"font-weight":"400","font-size":"0.8em"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }